import * as ids from 'short-id';
import { DEFAULT_PROGRESS_OPTIONS } from 'utils/embed/progress';
import { DEFAULT_TRACK_ORDER } from 'utils/embed/tracks';
import { stringToViewport } from 'utils/placement';
import {
  IntroOutroState,
  LayerState,
  MainImage,
  ProgressState,
} from '../types';

export const DEFAULT_INTRO_OUTRO_STATE: IntroOutroState = {};

export const DEFAULT_LAYER_STATE: LayerState = DEFAULT_TRACK_ORDER.reduce(
  (acc, trackType) => {
    // editor only supports media and text tracks
    if (trackType !== 'media' && trackType !== 'text') return acc;
    const id = ids.generate();
    const layer = { id, type: trackType };
    acc.data[id] = layer;
    acc.order.push(id);
    return acc;
  },
  { data: {}, order: [] },
);

export const DEFAULT_MAIN_IMAGE: MainImage = {
  ids: [],
  src: undefined,
};

export const DEFAULT_PATCH = {
  backgroundColor: undefined,
  hasCubeEffect: undefined,
  slideshow: undefined,
  soundwave: undefined,
  textOverlays: undefined,
  videoClips: undefined,
  watermark: undefined,
};

export const DEFAULT_BG_COLOR = 'black';

export const DEFAULT_ORDERED_STATE = {
  data: {},
  order: [],
};

export const DEFAULT_SLIDESHOW_STATE = {
  ...DEFAULT_ORDERED_STATE,
  newImages: [],
};

export const DEFAULT_PROGRESS_STATE: ProgressState = stringToViewport(
  DEFAULT_PROGRESS_OPTIONS,
);

export const DEFAULT_KEY_TEXT_ASSETS = {
  episodeTitle: undefined,
  mainText: undefined,
  podcastTitle: undefined,
};
